<template>
  <div class="button">
    <a target="_blank" :href="link">
      <slot />
    </a>
  </div>
</template>

<script>
export default {
  name: "Button",
  props: ["link"],
};
</script>

<style lang="scss" scoped>
@import "../styles/styles.scss";

.button {
  cursor: pointer;
  width: 221px;
  height: 48px;
  max-width: 100%;
  max-height: 100%;
  background: transparent;
  border: solid 2px #e95557;
  border-radius: 6px;
  margin: 1.5em auto;
  a {
    font-size: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #e95557;
  }
  &:hover {
    background: #e95557;
    a {
      color: #fff;
    }
  }
}
@include media(">=phone-md") {
  .button {
    width: 244px;
    height: 64px;
    a {
      font-size: 1.25em;
    }
  }
}
@include media(">=tablet") {
  .button {
    margin-left: 0px;
  }
}
</style>